import { render, staticRenderFns } from "./ProfilesComponent.vue?vue&type=template&id=19b92f4f"
import script from "./ProfilesComponent.vue?vue&type=script&lang=js"
export * from "./ProfilesComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfilesComponent.vue?vue&type=style&index=0&id=19b92f4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports